import { Box, RowsSkeletonLoader } from '@node-space/ui-components'
import { EarnDirectSummary } from '../../components/direct/EarnDirectSummary'
import { EarnAssetsList } from '../../components/EarnAssetsList'
import { EarnNoPortfolio } from '../../components/EarnNoPortfolio'
import { EarnNoProducts } from '../../components/EarnNoProducts'
import { EarnNoWallets } from '../../components/EarnNoWallets'
import { EarnPageHeader } from '../../components/EarnPageHeader'
import { useEarnDirectDashboardData } from '../../hooks/dashboard/useEarnDirectDashboardData'
import { EARN_DASHBOARD_STATE } from '../../types'
import { UseEarnPageDataHandlers } from '../../types/dashboardState'

export type EarnDirectViewProps = UseEarnPageDataHandlers

export const EarnDirectView = ({ onDeposit, onWithdraw }: EarnDirectViewProps) => {
  const viewData = useEarnDirectDashboardData({ onDeposit, onWithdraw })

  if (viewData.dashboardState === EARN_DASHBOARD_STATE.LOADING) {
    return <RowsSkeletonLoader rows={10} />
  }

  if (viewData.dashboardState === EARN_DASHBOARD_STATE.NO_PRODUCTS) {
    return <EarnNoProducts />
  }

  if (viewData.dashboardState === EARN_DASHBOARD_STATE.NO_WALLETS) {
    return <EarnNoWallets featuredProduct={viewData.featuredProduct} />
  }

  if (viewData.dashboardState === EARN_DASHBOARD_STATE.NO_PORTFOLIOS) {
    return <EarnNoPortfolio assets={viewData.assets} showCustomerEarnRate={false} />
  }

  return (
    <>
      <EarnPageHeader />
      <Box flexCol gap={24}>
        <EarnDirectSummary
          allocatedFunds={viewData.summary.allocatedFunds}
          availableFunds={viewData.summary.availableFunds}
          totalAllTimeEarnings={viewData.summary.totalAllTimeEarnings}
          isStatisticsLoading={viewData.isStatisticsLoading}
        />
        <EarnAssetsList assets={viewData.assets} showCustomerEarnRate={false} />
      </Box>
    </>
  )
}
